import { render, staticRenderFns } from "./BrowserPreview.vue?vue&type=template&id=470e1b86&scoped=true&"
import script from "./BrowserPreview.vue?vue&type=script&lang=js&"
export * from "./BrowserPreview.vue?vue&type=script&lang=js&"
import style0 from "./BrowserPreview.vue?vue&type=style&index=0&id=470e1b86&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470e1b86",
  null
  
)

export default component.exports